"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconButton = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
var react_1 = require("react");
var icons_1 = require("../../../styles/config/icons");
var theme_1 = __importDefault(require("../../../styles/theme"));
var styleUtilities_1 = require("../../../util/styleUtilities");
var CircularProgress_1 = require("../CircularProgress/CircularProgress");
var Icon_1 = require("../Icon/Icon");
var Link_1 = require("../Link/Link");
var Tooltip_1 = require("../Tooltip/Tooltip");
var IconButton_style_1 = __importDefault(require("./IconButton.style"));
/**
 * IconButton atom
 *
 * {@link https://stories.data.bmw.cloud/?path=/docs/atoms-buttons-iconbutton--bound-story Docs}
 * {@link https://github.com/bmw-cdh/cdh-data-portal-theme/tree/main/components/atoms/IconButton Source}
 */
var IconButton = function (_a) {
    var onClick = _a.onClick, icon = _a.icon, className = _a.className, _b = _a.iconSize, iconSize = _b === void 0 ? icons_1.defaultIconSize : _b, tooltip = _a.tooltip, stopPropagation = _a.stopPropagation, isActive = _a.isActive, isDisabled = _a.isDisabled, isLoading = _a.isLoading, _c = _a.variant, variant = _c === void 0 ? 'default' : _c, _d = _a.withoutReservedPadding, withoutReservedPadding = _d === void 0 ? false : _d, onMouseDown = _a.onMouseDown, url = _a.url, openLinkInNewTab = _a.openLinkInNewTab;
    var classes = (0, IconButton_style_1.default)();
    var containerSize = withoutReservedPadding ? iconSize : iconSize + 8;
    var rootClassNames = (0, classnames_1.default)(classes.root, className, 'hoverable');
    var isButtonDisabled = isDisabled || isLoading;
    var hoverElementClassNames = (0, classnames_1.default)(classes.hoverElement, isActive && (variant === 'default' ? classes.active : classes.alertActive), !isButtonDisabled && (variant === 'default' ? classes.enabled : classes.alertEnabled));
    function handleClick(event) {
        stopPropagation && event.stopPropagation();
        onClick === null || onClick === void 0 ? void 0 : onClick(event);
    }
    function getIconColor() {
        var opacityLevel = isButtonDisabled ? 0.4 : 1;
        var isAlert = variant === 'alert';
        if (isActive) {
            return (0, styleUtilities_1.withOpacity)(!isAlert ? theme_1.default.textColors.highlight : theme_1.default.textColors.error, opacityLevel);
        }
        return (0, styleUtilities_1.withOpacity)(!isAlert ? theme_1.default.textColors.primary : theme_1.default.textColors.error, opacityLevel);
    }
    function getIconHoverVariant() {
        if (isButtonDisabled) {
            return undefined;
        }
        if (variant === 'alert') {
            return 'errorDark';
        }
        return 'default';
    }
    // Our icons normally have 4px spacing on each side but circular progress does not have
    var circularProgressSize = Math.max(iconSize - 8, 8);
    var _e = (function () {
        if (withoutReservedPadding) {
            return {
                PaddingWrapper: 'div',
                paddingWrapperProps: {
                    className: (0, classnames_1.default)(classes.root, classes.hoverMask, hoverElementClassNames, 'hoverable'),
                    'data-testid': 'no-reserved-space-wrapper',
                },
            };
        }
        return {
            PaddingWrapper: react_1.Fragment,
            paddingWrapperProps: {},
        };
    })(), PaddingWrapper = _e.PaddingWrapper, paddingWrapperProps = _e.paddingWrapperProps;
    var ButtonComponent = url ? 'div' : 'button';
    return ((0, jsx_runtime_1.jsx)(Tooltip_1.Tooltip, __assign({ text: tooltip, className: (0, classnames_1.default)(rootClassNames, !withoutReservedPadding && hoverElementClassNames) }, { children: (0, jsx_runtime_1.jsx)("div", { children: url ? ((0, jsx_runtime_1.jsx)(Link_1.Link, __assign({ "aria-disabled": isButtonDisabled, onNavigate: handleClick, onMouseDown: onMouseDown, disabled: isButtonDisabled, openInNewTab: openLinkInNewTab, role: 'button', url: url }, { children: renderBase() }))) : (renderBase()) }) })));
    function renderBase() {
        return ((0, jsx_runtime_1.jsx)(ButtonComponent, __assign({ "aria-disabled": !url && isButtonDisabled, onClick: url ? undefined : handleClick, onMouseDown: url ? undefined : onMouseDown, disabled: isButtonDisabled, style: {
                width: containerSize,
                height: containerSize,
                // MUI Won't hide tooltip after leaving without this
                pointerEvents: isButtonDisabled ? 'none' : undefined,
            }, className: classes.button }, { children: (0, jsx_runtime_1.jsx)(PaddingWrapper, __assign({}, paddingWrapperProps, { children: isLoading ? ((0, jsx_runtime_1.jsx)(CircularProgress_1.CircularProgress, { size: circularProgressSize, color: getIconColor() })) : ((0, jsx_runtime_1.jsx)(Icon_1.Icon, { iconPath: icon, color: getIconColor(), size: iconSize, hoverVariant: getIconHoverVariant() })) })) })));
    }
};
exports.IconButton = IconButton;
